import type { Build } from '@/models/Build/Model'
import type { Export } from '@/models/Export/Model'
import type { RepositoryConfig } from '@/models/RepositoryConfig/Model'
import axios, { type AxiosResponse } from 'axios'

const apiUrl = import.meta.env.VITE_API_URL

export default class StripeApi {
	route = 'stripe'

	async checkout(params: {
		price_id: string
		quantity: number
		build_id: Build['id']
		repository_config_id?: RepositoryConfig['id']
		delivery_type?: 'git' | 'zip'
	}): Promise<AxiosResponse<{ redirect: string }>> {
		const res = await axios.post(`${apiUrl}/${this.route}/checkout`, params)
		window.location = res.data.redirect
		return res
	}

	async completeCheckout(params: { session_id: string }): Promise<
		AxiosResponse<{
			status: 'open' | 'complete' | 'expired'
			customer_email: string | null
			export: Export | null
		}>
	> {
		return await axios.post(`${apiUrl}/${this.route}/complete-checkout`, params)
	}
}
